import createIcon from '../../createIcon';

/**
 * @component @name ExposureNeg1
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC41IDExLjVWMTMuNUgxMi41VjExLjVINC41Wk0xOS41IDE4LjVIMTcuNVY3Ljg4TDE0LjUgOC45VjcuMkwxOS4yIDUuNUgxOS41VjE4LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ExposureNeg1 = createIcon('ExposureNeg1', [
  [
    'path',
    {
      d: 'M4.5 11.5V13.5H12.5V11.5H4.5ZM19.5 18.5H17.5V7.88L14.5 8.9V7.2L19.2 5.5H19.5V18.5Z',
      key: '1etnkr',
    },
  ],
]);

export default ExposureNeg1;
